import Graph from 'graph-data-structure';
import React, { useRef } from 'react';

import type { Menu, Page, Reference } from '@swf/cms';
import { useCMSReference } from '@swf/cms';

export const CMSMenuGraphContext = React.createContext(Graph());

interface Props {
  menu: Menu;
  maxDepth?: number;
}

type GraphType = ReturnType<typeof Graph>;

const MenuGraphItem = (
  reference: Reference,
  graph: GraphType,
  rootNode: string,
  previousNode: string
) => {
  const { page: pageRef, url, children: submenu } = useCMSReference<Menu>(reference) || {};
  const page = useCMSReference<Page>(pageRef?.[0]);
  const href = url || page?.url;

  if (href && !graph.shortestPath(rootNode, previousNode).includes(href)) {
    graph.addEdge(previousNode, href);
    submenu?.forEach((item) => MenuGraphItem(item, graph, rootNode, href));
  }
};

const CMSMenuGraphProvider: React.FC<Props> = ({ menu, children }) => {
  const graphRef = useRef(Graph());
  const { page: pageRef, url, children: submenu } = menu;
  const page = useCMSReference<Page>(pageRef?.[0]);
  const href = url || page?.url || '/';
  const graphNodes = graphRef.current.nodes();
  if (graphNodes.length > 0 && href !== graphNodes[0]) {
    graphRef.current = Graph();
  }

  graphRef.current.addNode(href);

  submenu.forEach((reference) => MenuGraphItem(reference, graphRef.current, href, href));

  return (
    <CMSMenuGraphContext.Provider value={graphRef.current}>{children}</CMSMenuGraphContext.Provider>
  );
};

export default CMSMenuGraphProvider;
